// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"6b5c9940","828":"71453b58"}[chunkId] + ".chunk.css";
};